// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchOnboardingOverhaul-cls1_TFC","cls2":"SearchOnboardingOverhaul-cls2_pmA SearchOnboardingOverhaul-cls1_TFC","wide":"SearchOnboardingOverhaul-wide_52q"};